module.exports = __webpack_public_path__ + "static/media/competition-alert.9bc07f66.svg";